/**
 * Admin-editable wording for the automated rental reminders (t1107). Each
 * message is a plain string with `{{placeholder}}` tokens that are filled in per
 * rental when it goes out.
 */
export const RENTAL_TEMPLATE_PLACEHOLDERS = [
    'customerName',
    'storeName',
    'rentalNumber',
    'dueDate',
];
const TOKEN = /\{\{([^{}]*)\}\}/g;
function isPlaceholder(name) {
    return RENTAL_TEMPLATE_PLACEHOLDERS.includes(name);
}
/** Fills in every known `{{token}}`; anything else is left exactly as written. */
export function renderRentalTemplate(template, values) {
    return template.replace(TOKEN, (token, name) => isPlaceholder(name) ? values[name] : token);
}
/** Names inside `{{…}}` that aren't one of the supported placeholders. */
export function unknownRentalPlaceholders(template) {
    const unknown = [];
    for (const match of template.matchAll(TOKEN)) {
        const name = match[1] ?? '';
        if (!isPlaceholder(name) && !unknown.includes(name))
            unknown.push(name);
    }
    return unknown;
}
/** The wording the reminders used before it became editable. */
export const RENTAL_TEMPLATE_DEFAULTS = {
    reminderEmailSubject: 'Your rental {{rentalNumber}} is due {{dueDate}}',
    reminderEmailBody: 'Hi {{customerName}},\n\n' +
        'This is a reminder that your {{storeName}} rental {{rentalNumber}} is due back on {{dueDate}}.\n\n' +
        'If you need more time, please contact us before then so we can extend it.\n\n' +
        'Thank you,\n{{storeName}}',
    reminderSmsBody: '{{storeName}}: your rental {{rentalNumber}} is due back on {{dueDate}}. ' +
        'Contact us if you need more time. Reply STOP to opt out.',
    overdueCustomerEmailSubject: 'Your rental {{rentalNumber}} is overdue',
    overdueCustomerEmailBody: 'Hi {{customerName}},\n\n' +
        'Your {{storeName}} rental {{rentalNumber}} was due back on {{dueDate}} and is now overdue.\n\n' +
        'Please return it as soon as you can, or contact us if you need more time.\n\n' +
        'Thank you,\n{{storeName}}',
    overdueCustomerSmsBody: '{{storeName}}: your rental {{rentalNumber}} was due back on {{dueDate}} and is now overdue. ' +
        'Please return it, or contact us if you need more time. Reply STOP to opt out.',
    overdueCallScript: 'Hello {{customerName}}. This is {{storeName}} calling about your rental {{rentalNumber}}. ' +
        'It was due back on {{dueDate}}. It is now overdue. Please return it as soon as you can, ' +
        'or contact the store if you need more time. Thank you.',
};
//# sourceMappingURL=rental-templates.js.map